import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'audio',
    'pauseButton',
    'playButton',
    'progress',
    'progressBar'
  ]

  connect () {
    // Initially hide pause buttons and progress bars
    this.hideAll(this.pauseButtonTargets)
    this.hideAll(this.progressTargets)

    this.setupProgress(this.audioTarget)
  }

  hide (element) {
    element.style.display = 'none'
  }

  hideAll (elements) {
    elements.forEach(function(element) {
      element.style.display = 'none'
    })
  }

  play (event) {
    const index = event.params.index
    this.audioTarget.dataset.index = index
    this.audioTarget.src = event.params.source
    this.audioTarget.load()

    // Show play button for all audio elements
    this.hideAll(this.pauseButtonTargets)
    this.showAll(this.playButtonTargets)

    // Show pause button for this audio element
    this.hide(this.playButtonTargets[index])
    this.show(this.pauseButtonTargets[index])

    // Show only current progress bar when playing
    this.hideAll(this.progressTargets)
    this.show(this.progressTargets[index])

    this.audioTarget.play()
  }

  pause (event) {
    const index = event.params.index

    // Show play button for this audio element
    this.show(this.playButtonTargets[index])
    this.hide(this.pauseButtonTargets[index])

    this.audioTarget.pause()
  }

  pauseAll () {
    // stop all other audio elements
    this.audioTargets.forEach(function(audioElement) {
      audioElement.pause()
    })
  }

  setupProgress (audioElement) {
    // Display progress
    audioElement.addEventListener('timeupdate', (event) => {
      const audio = event.target
      const index = audio.dataset.index
      const progressBar = this.progressBarTargets[index]
      progressBar.style.width = `${Math.floor(
        (audio.currentTime / audio.duration) * 100,
      )}%`;
    });
  }

  show (element) {
    element.style.display = 'block'
  }

  showAll (elements) {
    elements.forEach(function(element) {
      element.style.display = 'block'
    })
  }
}
